"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var Title = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: \"Lato\", \"sans-serif\";\n    line-height: ", ";\n    padding: ", ";\n    margin: ", ";\n    z-index: ", ";\n  }\n"], ["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: \"Lato\", \"sans-serif\";\n    line-height: ", ";\n    padding: ", ";\n    margin: ", ";\n    z-index: ", ";\n  }\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var fontSize = _a.fontSize, theme = _a.theme;
    return utils_1.parseThemePath(fontSize, theme, '30px');
}, function (_a) {
    var fontWeight = _a.fontWeight, theme = _a.theme;
    return lodash_1.get(theme, fontWeight, '700');
}, function (_a) {
    var lineHeight = _a.lineHeight, theme = _a.theme;
    return lodash_1.get(theme, lineHeight, '1.2');
}, function (_a) {
    var padding = _a.padding;
    return padding ? padding : '0';
}, function (_a) {
    var margin = _a.margin;
    return margin ? margin : '0 0 6px 0';
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex ? zIndex : 'auto';
});
var AXSPageTitle = function (props) {
    return (React.createElement(Title, __assign({ theme: props.theme }, props, { className: classnames_1.default(['c-axs-page-title', props.className]) }), props.children));
};
AXSPageTitle.defaultProps = {
    color: 'axsui.components.pageTitle.titleColor',
    fontSize: 'axsui.components.pageTitle.fontSize',
    fontWeight: 'axsui.components.pageTitle.fontWeight',
};
exports.default = AXSPageTitle;
var templateObject_1;
//# sourceMappingURL=index.js.map